export default __webpack_public_path__ + "static/media/dummy.aca7a35a601a679d89bb5ed11afac190.png";